import React from 'react'

interface INavTabIconProps {
    /** Raw svg markup, inlined at build time by svg-inline-loader. */
    svg: string
}

/**
 * A tab's icon, inlined rather than <img> so `currentColor` picks up the tab's colour.
 * Sized by BottomNav.scss, since Meridian's Icon hard-codes 16/24px.
 */
const NavTabIcon = ({ svg }: Readonly<INavTabIconProps>): React.ReactElement => (
    <span
        className="bottom-nav-icon"
        aria-hidden="true"
        // Not user input: `svg` is only ever a build-time import from src/assets/icons/.
        dangerouslySetInnerHTML={{ __html: svg }}
    />
)

export default NavTabIcon
